import { Head } from '@/components/head'
import { TestpaymentSuccessPage } from '@/features/test-payment/components/test-payment-success-page'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'


// todo: use lazy route
export const Route = createFileRoute('/test-payment/success/$diagnosticTestId')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      reference: z.string().optional(),
      referralId: z.string().optional(),
    }),
  ),
})

function RouteComponent() {
  const { diagnosticTestId } = Route.useParams()
  const { reference, referralId } = Route.useSearch()

  return (
    <>
      <Head title="Payment Successful" />
      <TestpaymentSuccessPage diagnosticTestId={diagnosticTestId} reference={reference} referralId={referralId} />
    </>
  )
}
